/* =========================================================
   Hanok Studio — shared storefront behavior
   Mobile nav · gallery filters · shop filters ·
   product variants/qty · consultation reference upload
   ========================================================= */
(function () {
  "use strict";

  /* ---------- 1. MOBILE NAV ---------- */
  function buildMobileNav() {
    var header = document.querySelector(".site-header .container");
    var nav = document.querySelector(".site-nav");
    if (!header || !nav || document.querySelector(".nav-toggle")) return;

    var toggle = document.createElement("button");
    toggle.className = "nav-toggle";
    toggle.type = "button";
    toggle.setAttribute("aria-label", "Menu");
    toggle.setAttribute("aria-expanded", "false");
    toggle.innerHTML = "<span></span><span></span><span></span>";
    header.appendChild(toggle);

    var drawer = document.createElement("div");
    drawer.className = "mobile-drawer";
    var links = "";
    nav.querySelectorAll("a").forEach(function (a) {
      var cls = a.classList.contains("book") ? ' class="book"' : "";
      links += '<a href="' + a.getAttribute("href") + '"' + cls + ">" + a.textContent + "</a>";
    });

    var visit = document.querySelector(".site-footer .footer-grid");
    var visitHtml = "";
    if (visit) {
      var tel = visit.querySelector('a[href^="tel:"]');
      if (tel) visitHtml = '<div class="drawer-visit"><a href="' + tel.getAttribute("href") + '">' + tel.textContent + "</a></div>";
    }

    drawer.innerHTML = '<button class="drawer-close" type="button" aria-label="Close menu">&times;</button>' + links + visitHtml;
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-modal", "true");
    drawer.setAttribute("aria-label", "Menu");
    drawer.setAttribute("hidden", "");
    document.body.appendChild(drawer);

    var scrollY = 0;
    function focusables() {
      return Array.prototype.slice.call(drawer.querySelectorAll("a[href], button:not([disabled])"));
    }
    function close() {
      if (!document.body.classList.contains("nav-open")) return;
      document.body.classList.remove("nav-open");
      toggle.setAttribute("aria-expanded", "false");
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
      setTimeout(function () { if (!document.body.classList.contains("nav-open")) drawer.setAttribute("hidden", ""); }, 450);
      toggle.focus();
    }
    function open() {
      scrollY = window.pageYOffset || document.documentElement.scrollTop;
      drawer.removeAttribute("hidden");
      // next frame so the transition runs from the off-screen state
      requestAnimationFrame(function () {
        document.body.classList.add("nav-open");
        toggle.setAttribute("aria-expanded", "true");
        // lock the page behind the drawer without losing scroll position
        document.body.style.position = "fixed";
        document.body.style.top = -scrollY + "px";
        document.body.style.width = "100%";
        var f = focusables();
        if (f.length) f[0].focus();
      });
    }
    toggle.addEventListener("click", function () {
      document.body.classList.contains("nav-open") ? close() : open();
    });
    drawer.querySelector(".drawer-close").addEventListener("click", close);
    drawer.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", close); });

    document.addEventListener("keydown", function (e) {
      if (!document.body.classList.contains("nav-open")) return;
      if (e.key === "Escape") { close(); return; }
      if (e.key === "Tab") {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // close if the viewport grows back to desktop while open
    var rt;
    window.addEventListener("resize", function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (window.innerWidth > 800 && document.body.classList.contains("nav-open")) close();
      }, 150);
    });
  }

  /* ---------- 2. GALLERY STYLE FILTERS ---------- */
  function setupGalleryFilters() {
    var filterWrap = document.querySelector("[data-style-filters]");
    var grid = document.querySelector("[data-style-grid]");
    if (!filterWrap || !grid) return;
    var chips = Array.prototype.slice.call(filterWrap.querySelectorAll("[data-filter]"));
    var tiles = Array.prototype.slice.call(grid.children);

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("active"); });
        chip.classList.add("active");
        var want = (chip.getAttribute("data-filter") || "").toLowerCase();
        var shown = 0;
        tiles.forEach(function (t) {
          var s = (t.getAttribute("data-style") || "").toLowerCase();
          var match = want === "all" || s.split("|").indexOf(want) > -1;
          t.classList.toggle("is-hidden", !match);
          if (match) shown++;
        });
        var empty = grid.parentNode.querySelector("[data-filter-empty]");
        if (empty) empty.style.display = shown ? "none" : "";
      });
    });
  }

  /* ---------- 3. SHOP CATEGORY FILTERS ---------- */
    function setupShopFilters() {
    var filterWrap = document.querySelector("[data-shop-filters]");
    if (!filterWrap) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll(".product-card"));
    if (!cards.length) return;
    var chips = Array.prototype.slice.call(filterWrap.querySelectorAll("span"));
    chips.forEach(function (chip) {
      if (chip.classList.contains("coming-soon")) return;
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("active"); });
        chip.classList.add("active");
        var want = chip.textContent.trim().toLowerCase();
        cards.forEach(function (card) {
          var raw = card.getAttribute("data-cat");
          if (!raw) raw = ((card.querySelector(".cat") || {}).textContent || "");
          var list = raw.toLowerCase().replace(/-/g, " ").split(",").map(function (x) { return x.trim(); });
          var match = want === "all" || list.indexOf(want) > -1;
          card.style.display = match ? "" : "none";
        });
      });
    });
  }

  /* ---------- 4. PRODUCT VARIANTS + QTY (product page only) ---------- */
  function money(cents) {
    try { return "$" + (cents / 100).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return "$" + (cents / 100).toFixed(2); }
  }
  function setupProduct() {
    var pdp = document.querySelector(".product-pdp-details");
    if (!pdp) return; // never runs on cart/other pages

    var current = pdp.querySelector(".current-variant");
    var priceEl = pdp.querySelector(".product-price");
    var compareEl = pdp.querySelector(".product-compare-price");
    var saveEl = pdp.querySelector(".product-save-badge");
    var skuEl = pdp.querySelector(".product-sku");
    var select = pdp.querySelector(".product-variant-select");
    var rows = pdp.querySelectorAll(".variant-options");
    var product = window.HANOK_PRODUCT || null;

    function selectedValues() {
      return Array.prototype.map.call(rows, function (row) {
        var a = row.querySelector(".variant-opt.active");
        return a ? a.textContent.trim() : null;
      });
    }
    function findVariant(vals) {
      if (!product) return null;
      return product.variants.filter(function (v) {
        return vals.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }
    function apply(v) {
      if (!v) return;
      if (select) { select.value = v.id; select.dispatchEvent(new Event("change", { bubbles: true })); }
      if (priceEl) priceEl.textContent = money(v.price) + " CAD";
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = "";
          if (saveEl) { saveEl.textContent = "Save " + money(v.compare_at_price - v.price); saveEl.style.display = ""; }
        } else {
          compareEl.style.display = "none";
          if (saveEl) saveEl.style.display = "none";
        }
      }
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      pdp.querySelectorAll('.product-buy-row button[type="submit"]').forEach(function (b) {
        b.disabled = !v.available;
        if (b.classList.contains("btn-primary")) b.textContent = v.available ? "Add to Cart" : "Sold Out";
      });
    }

    rows.forEach(function (row, rowIndex) {
      row.querySelectorAll(".variant-opt").forEach(function (opt) {
        opt.addEventListener("click", function () {
          row.querySelectorAll(".variant-opt").forEach(function (o) { o.classList.remove("active"); });
          opt.classList.add("active");
          if (current && rowIndex === 0) current.textContent = opt.textContent.trim();
          apply(findVariant(selectedValues()));
        });
      });
    });

    var qtyWrap = pdp.querySelector(".qty-selector");
    if (qtyWrap) {
      var val = qtyWrap.querySelector("span");
      var hidden = qtyWrap.querySelector(".qty-input");
      var btns = qtyWrap.querySelectorAll("button");
      if (val && btns.length >= 2) {
        var sync = function () { if (hidden) hidden.value = val.textContent; };
        btns[0].addEventListener("click", function (e) { e.preventDefault(); val.textContent = Math.max(1, parseInt(val.textContent, 10) - 1); sync(); });
        btns[1].addEventListener("click", function (e) { e.preventDefault(); val.textContent = parseInt(val.textContent, 10) + 1; sync(); });
      }
    }
  }

  /* ---------- 5. CONSULTATION REFERENCE UPLOAD ---------- */
  function setupFileDrop() {
    var drop = document.querySelector(".file-drop");
    if (!drop) return;
    var input = drop.querySelector('input[type="file"]');
    if (!input) return;
    var thumbs = document.querySelector(".file-thumbs");
    if (!thumbs) {
      thumbs = document.createElement("div");
      thumbs.className = "file-thumbs";
      drop.parentNode.insertBefore(thumbs, drop.nextSibling);
    }

    drop.addEventListener("click", function (e) { if (e.target !== input) input.click(); });
    drop.addEventListener("dragover", function (e) { e.preventDefault(); drop.classList.add("is-dragover"); });
    drop.addEventListener("dragleave", function () { drop.classList.remove("is-dragover"); });
    drop.addEventListener("drop", function (e) {
      e.preventDefault(); drop.classList.remove("is-dragover");
      if (e.dataTransfer.files && e.dataTransfer.files.length) {
        try { input.files = e.dataTransfer.files; } catch (err) {}
        render();
      }
    });
    input.addEventListener("change", render);

    function render() {
      thumbs.innerHTML = "";
      Array.prototype.forEach.call(input.files || [], function (f) {
        if (!/^image\//.test(f.type)) return;
        var r = new FileReader();
        r.onload = function () {
          var t = document.createElement("div");
          t.className = "thumb";
          t.style.backgroundImage = "url(" + r.result + ")";
          t.title = f.name;
          thumbs.appendChild(t);
        };
        r.readAsDataURL(f);
      });
    }
  }

  /* ---------- 7. DIRECT-EMAIL FORM SUCCESS ---------- */
  function setupFormSuccess() {
    if (window.location.search.indexOf("sent=1") === -1) return;
    var notes = document.querySelectorAll("[data-form-success], [data-amb-success]");
    if (!notes.length) return;
    notes.forEach(function (n) { n.style.display = ""; });
    var first = notes[0];
    if (first && first.getBoundingClientRect().top > window.innerHeight) {
      window.scrollTo(0, first.getBoundingClientRect().top + window.pageYOffset - 120);
    }
  }

  /* ---------- INIT ---------- */
  function init() {
    buildMobileNav();
    setupGalleryFilters();
    setupShopFilters();
    setupProduct();
    setupFileDrop();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
